import axios from "axios";
import { authHeaderJson } from "./auth-header.service";




const getAllRoles = () => {
  return axios.post(`/api//role-sg3/get-all`, null, { headers: authHeaderJson() } );
};



export default {
  getAllRoles
};